document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.filters-toggler').forEach(function (element) {
		element.addEventListener('click', function () {
			document.body.classList.toggle('filters-active');
		});
	});
	document.querySelectorAll('.favorites-toggler').forEach(function (element) {
		element.addEventListener('click', function () {
			document.body.classList.toggle('favorites-active');
		});
	});
});